import { HANDRAISER_NAME_SRP } from 'constants/handraiser';
import { useAuthentication } from 'hooks/authentication';
import { useChatContext } from 'hooks/chatContext';
import { useUrlListener } from 'hooks/useUrlListener';
import { getHandraiser } from 'services/chatBackend/handraiser';
import { DynamicHandraiserNameType } from 'services/chatBackend/types/handraiser';
import { DataDogLogger } from 'utils/dataDog';

export const useDynamicHandraiser = (handraiserName: DynamicHandraiserNameType) => {
  const { authenticationState } = useAuthentication();
  const { chatContextState } = useChatContext();
  const { url } = useUrlListener(true);

  const getHandraiserContext = () => {
    switch (handraiserName) {
      case HANDRAISER_NAME_SRP:
        return {
          current_url: url,
          search_result_count: window.merch.totalMatchedInventory,
        };
      default:
        return {
          current_url: url,
        };
    }
  };

  const runMayShowHandRaiser = async () => {
    switch (handraiserName) {
      case HANDRAISER_NAME_SRP:
        return await window.merch.mayNudgeShow(HANDRAISER_NAME_SRP);
      default:
        return {
          mayShow: false,
          error: 'Unable to retrieve handraiser show condition for this page',
          reason: `Mapping does not exist for provided handraiser: ${handraiserName}`,
        };
    }
  };

  const getDynamicHandraiserData = async () => {
    const handraiserContext = getHandraiserContext();
    const currentState = { authenticationState, chatContextState };
    try {
      return await getHandraiser(currentState, handraiserContext, handraiserName);
    } catch (error) {
      const loggerMsg = 'Error getting dynamic handraiser content'; // temp. while trying to debug why catch is spamming our DataDog logs.
      console.error(loggerMsg, { error });
      DataDogLogger.error(new Error(loggerMsg), {
        error,
        handraiserName,
        handraiserContext,
      });
    }
  };

  return { runMayShowHandRaiser, getDynamicHandraiserData };
};
